import React from 'react'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import star_icon from '../../assets/images/icons/star-icon.png'




const GreenRadio = withStyles({
    root: {
      color: green[400],
      '&$checked': {
        color: green[600],
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);



const index = (props)=>{
    return(
        <div className="dashboard-textfield-container">
            <div className="dashboard-textfield-title">
                <span className="general-span-text">{props.title}</span>
                {props.required && <div>
                        <img src={star_icon}/>
                    </div>}
            </div>
            <div className="dashboard-textfield-input"
                style={{
                    border: 'none',
                    flexDirection: 'column',
                    }}>
                <FormControl component="fieldset">
                  <RadioGroup  
                    style={{
                      display: 'flex',
                      width: '100%',
                    }}
                    aria-label="gender" 
                    name="gender1" 
                    value={props.genderValue || ''} 
                    onChange={props.handleGenderChange}>
                    <FormControlLabel value="Male" control={<GreenRadio />} label="Male" />
                    <FormControlLabel value="Female" control={<GreenRadio />} label="Female"/>
                  </RadioGroup>
              </FormControl>
            </div>
        </div>

    )
}

export default index